import { render, staticRenderFns } from "./vipLevel.vue?vue&type=template&id=54e0c31c&scoped=true"
import script from "./vipLevel.vue?vue&type=script&lang=js"
export * from "./vipLevel.vue?vue&type=script&lang=js"
import style0 from "./vipLevel.vue?vue&type=style&index=0&id=54e0c31c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e0c31c",
  null
  
)

export default component.exports